import AdPaginationGroup from './AdPaginationGroup';

export default AdPaginationGroup;
